<template>
  <div class="admin-bank-users-page">
    <admin-navbar/>
    <b-container class="bg-white shadow-sm p-4">
      <h2>Bank Users</h2>
      <h3>{{ currentBankName }}</h3>

      <hr>

      <h3>Users</h3>

      <section v-if="userList.length">
        <p v-for="user in userList" :key="user.id"><router-link :to="'/admin/users/'+user.id">{{ user.name }}</router-link></p>
      </section>
      <section v-else>
        <p><em>No users.</em></p>
      </section>

      <hr>

      <h3>New User</h3>

      <b-form-group label="User Name">
        <b-form-input ref="newUserName" v-model="newUserForm.name" trim @keyup.enter="addNewUser"></b-form-input>
      </b-form-group>

      <b-form-group label="User Email">
        <b-form-input ref="newUserEmail" v-model="newUserForm.email" trim @keyup.enter="addNewUser"></b-form-input>
      </b-form-group>

      <b-form-group label="User Company Name">
        <b-form-input ref="newUserCompanyName" v-model="newUserForm.company_name" trim @keyup.enter="addNewUser"></b-form-input>
      </b-form-group>

      <b-form-group label="User Phone Number">
        <b-form-input ref="newUserPhone" v-model="newUserForm.phone_number" trim @keyup.enter="addNewUser"></b-form-input>
      </b-form-group>

      <b-button variant="primary" @click="addNewUser">+ Add User</b-button>

    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AdminNavbar from '@/components/AdminNavbar.vue'

export default {
  name: 'AdminBankUsers',
  components: {
    AdminNavbar
  },
  data () {
    return {
      userList: [],
      newUserForm: {
        name:         '',
        email:        '',
        company_name: '',
        bank_id:      null,
        phone_number: '',
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentBank',
      'currentBankId',
      'currentBankName'
    ])
  },
  methods: {
    ...mapActions([
      'loadBank',
      'getBankUsers',
      'postNewBankUser'
    ]),

    async loadUsers () {
      console.log('loadUsers')
      const result = await this.getBankUsers(this.currentBank.id)
      console.log('  loadUsers result', result)
      if (result.success) {
        this.userList = result.data
      }
    },

    async addNewUser () {
      console.log('addNewUser', this.newUserForm)
      if (!this.newUserForm.name) {
        this.$refs.newUserName.focus()
        return
      }
      if (!this.newUserForm.email) {
        this.$refs.newUserEmail.focus()
        return
      }
      if (!this.newUserForm.company_name) {
        this.$refs.newUserCompanyName.focus()
        return
      }
      if (!this.newUserForm.phone_number) {
        this.$refs.newUserPhone.focus()
        return
      }
      const result = await this.postNewBankUser({
        name:         this.newUserForm.name,
        username:     this.newUserForm.email,
        company_name: this.newUserForm.company_name,
        phone_number: this.newUserForm.phone_number,
        bank_id:      this.currentBank.id,
      })
      console.log('  result', result)
      if (result.success) {
        this.loadUsers()
      }
    },

  },
  async mounted () {
    console.log('AdminBankUsers.mounted')
    console.log('  route bankId', this.$route.params.bankId)
    console.log('  currentBank', this.currentBank)
    if (!this.currentBankId) {
      await this.loadBank(this.$route.params.bankId)
    }
    if (this.currentBankId) {
      this.loadUsers()
    }
  },
  watch: {
    async currentBank (newVal, oldVal) {
      console.log('currentBank changed', oldVal, newVal)
      if (oldVal.id === null && newVal.id !== null) {
        this.loadUsers()
      }
    }
  }
}
</script>

<style scoped>
</style>
